import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import api, { errText } from "../../lib/api";
import { Button } from "../ui/button";
import { Sparkle, CircleNotch } from "@phosphor-icons/react";

const SECTIONS = [
  ["workload", "Workload"],
  ["deadlines", "Deadlines"],
  ["stalled", "Stalled returns"],
];

export function FirmDigest() {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["firm-digest"], queryFn: () => api.get("/firm-digest").then((r) => r.data) });
  const gen = useMutation({
    mutationFn: () => api.post("/firm-digest/generate"),
    onSuccess: () => { toast.success("Monday briefing ready"); qc.invalidateQueries({ queryKey: ["firm-digest"] }); },
    onError: (e) => toast.error(errText(e)),
  });
  const c = data?.digest?.content;
  return (
    <div className="rounded-lg border border-zinc-900 bg-zinc-900 text-white p-5" data-testid="firm-digest">
      <div className="flex items-center justify-between gap-3 mb-1">
        <h3 className="text-sm font-medium flex items-center gap-1.5"><Sparkle size={15} /> Monday production briefing</h3>
        <Button data-testid="firm-digest-generate-btn" size="sm" variant="secondary" className="h-7 text-[11px]" disabled={gen.isPending} onClick={() => gen.mutate()}>
          {gen.isPending ? <CircleNotch size={12} className="animate-spin mr-1" /> : <Sparkle size={12} className="mr-1" />}
          {c ? "Refresh" : "Generate briefing"}
        </Button>
      </div>
      {!c ? (
        <p className="text-[11px] text-zinc-400">Workload by preparer, looming deadlines, and stalled returns — synthesized across every client in one note.</p>
      ) : (
        <div className="mt-2" data-testid="firm-digest-content">
          <p className="text-sm font-medium mb-3">{c.headline}</p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {SECTIONS.map(([key, label]) => (
              <div key={key}>
                <p className="text-[10px] uppercase tracking-wide text-zinc-400 mb-1.5">{label}</p>
                {(c[key] || []).map((l, i) => <p key={i} className="text-[11px] text-zinc-200 mb-1">{l}</p>)}
              </div>
            ))}
          </div>
          {(c.priorities || []).length > 0 && (
            <div className="mt-3 pt-3 border-t border-zinc-700">
              <p className="text-[10px] uppercase tracking-wide text-zinc-400 mb-1.5">This week's priorities</p>
              <div className="flex flex-wrap gap-x-6 gap-y-1">
                {(c.priorities || []).map((p, i) => <p key={i} className="text-[11px] text-emerald-300">→ {p}</p>)}
              </div>
            </div>
          )}
          <p className="text-[9px] text-zinc-500 mt-2">Generated {new Date(data.digest.generated_at).toLocaleString()}{!data?.fresh && " · refresh for this week"}</p>
        </div>
      )}
    </div>
  );
}
